import React, { useState, useEffect } from 'react'
import '../../assets/css/BiolLinkPage.css'
import { Copy, QrCode } from 'lucide-react';
import { toast } from 'react-toastify';
import BiolinkQRCode from './BiolinkQRCode';
import { useNavigate } from 'react-router-dom';
import BiolinkSubscription from './BiolinkSubscription';
import defaultProfile from '../../../src/assets/images/1 Logo AD1.png'
import defaultBanner from '../../../src/assets/images/1 Bill AD1.png'
import thumbImage from '../../../src/assets/images/hand3.png'
import Swal from 'sweetalert2'
import { useDispatch } from 'react-redux'
import { userSelfDelete } from '../../redux/slice/UserSelfDelete'

export default function BiolinkPreview({ bool, setBool, backgroundType, selectedBackground, selectedFontFamily, selectedFontColor, profilePhoto, profilePhoto2, showProfilePhoto, title, showTitle, paragraph, showParagraph, bannerImage, bannerImage2, showBanner, socialLinks, youtubeVideos = [], isSelfDeleted = false, userStatus = 'Active' }) {

    // const handleFollow = () => {
    //     // Preview only - toggle for preview display
    //     setFollowed(!followed);
    // };
    // console.log("selectedFontColor",selectedFontColor)

    console.log(profilePhoto)
    console.log(profilePhoto2)

    const [qrShow, setQRShow] = useState(false)
    const [show2, setShow2] = useState(false);
    const [selfDeleted, setSelfDeleted] = useState(!!isSelfDeleted)
    const [accountStatus, setAccountStatus] = useState(userStatus || 'Active')
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        setSelfDeleted(!!isSelfDeleted)
        setAccountStatus(userStatus || 'Active')
    }, [isSelfDeleted, userStatus])

    const showDeleteBtn = !selfDeleted
    const showRevokeBtn = selfDeleted && (accountStatus === 'Active' || accountStatus === 'Inactive')

    const handleDeleteUser = () => {
        Swal.fire({
            title: "Delete User",
            text: "Are you sure you want to delete it?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(userSelfDelete({ user_id: localStorage.getItem('id') })).then((res) => delete_res(res.payload))
            }
        })
    }

    const handleRevokeUser = () => {
        Swal.fire({
            title: "Revoke Delete",
            text: "Are you sure you want to revoke the delete request?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Revoke'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(userSelfDelete({
                    user_id: localStorage.getItem('id'),
                    type: 'revoke'
                })).then((res) => revoke_res(res.payload))
            }
        })
    }

    const delete_res = (res) => {
        if (res?.status == 200 || res?.status == 201) {
            const resData = res?.data
            const nextSelfDeleted = resData?.is_self_deleted === true
            const nextStatus = resData?.user_status || resData?.data?.[0]?.status || accountStatus
            setSelfDeleted(nextSelfDeleted)
            setAccountStatus(nextStatus)
            Swal.fire(
                "User Deleted",
                resData?.message || 'User Deleted Successfully',
                'success'
            )
            if (nextSelfDeleted && nextStatus === 'Deleted') {
                localStorage.clear();
                navigate('/home');
            }
        } else {
            toast.error(res?.data?.message || 'Something went wrong', { position: "bottom-right" })
        }
    }

    const revoke_res = (res) => {
        if (res?.status == 200 || res?.status == 201) {
            const resData = res?.data
            const nextSelfDeleted = resData?.is_self_deleted === true
            const nextStatus = resData?.user_status || resData?.data?.[0]?.status || accountStatus
            setSelfDeleted(nextSelfDeleted)
            setAccountStatus(nextStatus)
            Swal.fire(
                "Revoked",
                resData?.message || 'Delete request revoked successfully',
                'success'
            )
        } else {
            toast.error(res?.data?.message || 'Something went wrong', { position: "bottom-right" })
        }
    }

    // Get preview background style
    const getPreviewBackground = () => {
        if (backgroundType === 'solid') {
            return { backgroundColor: selectedBackground }
        } else {
            return { background: selectedBackground }
        }
    }

    // Get font family style
    const getFontStyle = () => {
        return {
            fontFamily: selectedFontFamily,
            color: selectedFontColor
        }
    }

    // COPY URL CODE---------------------------


    const getShortUrl = (shortCode) => {
        const baseUrl = (process.env.REACT_APP_BASE_URL || 'https://ad1.page').replace(/\/$/, '');
        return `${baseUrl}/x/${shortCode}`;
    };

    const handleCopyUrl = () => {
        const shortUrl = getShortUrl(localStorage.getItem('user_name'));
        navigator.clipboard.writeText(shortUrl).then(() => {
            toast.success('URL copied to clipboard!', {
                position: "bottom-right",
                closeOnClick: true
            });
        }).catch((err) => {
            console.error('Failed to copy:', err);
            toast.error('Failed to copy URL', { position: "bottom-right" });
        });
    };

    // QR CODE MODEL ------------

    const handleQR = (data) => {
        setQRShow(true)
    }

    const subscription_fun = () => {
        setShow2(true)
    }

    const profile_analytics = () => {
        navigate('/profile-analytics-list')
    }

    return (
        <>
            <div className="biolink-preview-panel">
                <div className='d-flex justify-content-between align-items-center '>
                    <h6 className='mt-1'>Bio Page URL </h6>

                    <button className='btn btn-sm btn-secondary mb-2' onClick={() => { localStorage.getItem('biolink_status') == 'paid' ? profile_analytics() : subscription_fun() }}>DOWNLOAD ANALYTICS</button>
                    {/* : <button className='btn btn-sm btn-warning mb-2' onClick={() => subscription_fun()}>{localStorage.getItem('biolink_status') == 'free' ?'SUBSCRIBE': 'RENEW'}</button>
                     } */}
                </div>

                <h6 className='text-primary' style={{ wordBreak: 'break-all' }}>
                    <a href={getShortUrl(localStorage.getItem('user_name'))} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                        {getShortUrl(localStorage.getItem('user_name'))}
                    </a>
                </h6>
                <div className="d-flex justify-content-between align-items-center biolink-preview-header">
                    <h6>Preview</h6>
                    <div className='d-flex align-items-center'>
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => handleCopyUrl()}
                            title="Copy URL"
                        >
                            <Copy size={15} className='mb-1' />
                        </button>
                        <button
                            className='ms-2 btn btn-sm btn-info'
                            onClick={() => handleQR()}
                            title="QR Code"
                        >
                            <QrCode size={15} className='mb-1' />
                        </button>
                    </div>
                </div>
                <div className="biolink-phone-container">
                    <div className="biolink-phone-frame">
                        <div
                            className="biolink-phone-screen"
                            style={getPreviewBackground()}
                        >
                            <div className="biolink-phone-content" style={getFontStyle()}>
                                {showProfilePhoto === true || showProfilePhoto === 'true' ?
                                    <div className="biolink-profile-photo-preview">
                                        <img src={profilePhoto || profilePhoto2 || defaultProfile} alt="Profile"
                                            style={{ objectFit: profilePhoto || profilePhoto2 ? 'cover' : 'contain' }} />
                                    </div>
                                    : ''}

                                <>
                                    {showTitle === true || showTitle === 'true' ? <h5 className='text-center biolink-title-preview'>{title}</h5> : ''}
                                    <div className="biolink-action-buttons d-flex justify-content-center gap-2 mt-3">
                                        <button
                                            className="biolink-social-link-item" style={{ borderRadius: '5px' }}
                                        >
                                            Follow
                                        </button>
                                    </div>
                                </>

                                {showParagraph === true || showParagraph === 'true' ?
                                    <p className='text-center biolink-paragraph-preview'>{paragraph}</p>
                                    : ''}
                                {showBanner === true || showBanner === 'true' ?
                                    <div className="biolink-banner-preview-phone">
                                        <img src={bannerImage || bannerImage2 || defaultBanner} alt="Banner"
                                            style={{ objectFit: bannerImage || bannerImage2 ? 'contain' : '', borderRadius: '10px' }} />
                                    </div>
                                    : ''}
                                {youtubeVideos.filter(video => !(video.is_hidden === true || video.is_hidden === 'true') && video.youtube_status !== 'deleted').length > 0 && (
                                    <div className="biolink-videos-preview">
                                        {youtubeVideos.filter(video => !(video.is_hidden === true || video.is_hidden === 'true') && video.youtube_status !== 'deleted').map((video, index) => {
                                            const videoId = video.videoId || video.video_id
                                            const thumbnail = video.thumbnail || (videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null)
                                            const videoUrl = video.url || (videoId ? `https://www.youtube.com/watch?v=${videoId}` : '#')
                                            return (
                                                <div key={video.id || video._id || index} className="biolink-video-preview-item">
                                                    <a
                                                        // href={videoUrl}
                                                        // target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="biolink-video-preview-link"
                                                    >
                                                        {thumbnail ? (
                                                            <img
                                                                src={thumbnail}
                                                                alt="Video thumbnail"
                                                                className="biolink-video-preview-thumbnail"
                                                                onError={(e) => {
                                                                    if (videoId) {
                                                                        e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
                                                                    } else {
                                                                        e.target.style.display = 'none'
                                                                        e.target.nextSibling.style.display = 'flex'
                                                                    }
                                                                }}
                                                            />
                                                        ) : null}
                                                        <div className="biolink-video-preview-placeholder" style={{ display: thumbnail ? 'none' : 'flex' }}>
                                                            {/* <div className="biolink-video-preview-play-icon">
                                                                <img src={thumbImage} alt="" height={'30px'} style={{borderRadius:'50%'}}/>
                                                            </div>
                                                            <span>Video</span> */}
                                                        </div>
                                                        <div className="biolink-video-preview-overlay">
                                                            {/* <div className="biolink-video-preview-play-icon"> */}
                                                            <img src={thumbImage} alt="" height={'30px'} style={{ borderRadius: '50%' }} />
                                                            {/* </div> */}
                                                        </div>
                                                    </a>
                                                    {video.url_name && (
                                                        <div className="biolink-video-preview-name">
                                                            {video.url_name}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                                {socialLinks.filter(link => !(link.is_hidden === true || link.is_hidden === 'true') && link.social_status !== 'deleted').length > 0 && (
                                    <div className="biolink-social-links-preview">
                                        {socialLinks.filter(link => !(link.is_hidden === true || link.is_hidden === 'true') && link.social_status !== 'deleted').map((link, index) => {
                                            const linkId = link.id || link._id || index;
                                            const linkName = link.name || 'Link';
                                            return (
                                                <a
                                                    key={linkId}
                                                    // href={link.url}
                                                    // target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="biolink-social-link-item"
                                                >
                                                    {linkName}
                                                </a>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="biolink-preview-bottom-actions">
                    {showDeleteBtn && (
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={handleDeleteUser}>
                            Delete User
                        </button>
                    )}
                    {showRevokeBtn && (
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={handleRevokeUser}>
                            Revoke
                        </button>
                    )}
                </div>
            </div>
            <BiolinkQRCode qrShow={qrShow} setQRShow={setQRShow} />
            <BiolinkSubscription show2={show2} setShow2={setShow2} bool={bool} setBool={setBool} />
        </>
    )
}

